import Stack from "@mui/material/Stack";
import GoogleLoginView from "./socialMedia/GoogleLoginView";
import TwiterXIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import Button from "@mui/material/Button";

const SocialMediaLoginView = () => {
    const styles = {
        label: {
            fontWeight: 600,
            mb: .5
        },
    }
    return (
        <Stack spacing={1} direction="row" justifyContent="center" alignItems="center">
            <GoogleLoginView />
            {/*<Button sx={styles.socialLoginbtn}> <FacebookIcon /> </Button>
            <Button sx={styles.socialLoginbtn}> <TwiterXIcon /> </Button>
            <Button sx={styles.socialLoginbtn}> <InstagramIcon /> </Button>*/}
        </Stack>
    );
};

export default SocialMediaLoginView;